/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import {Link} from "react-router-dom";
import CarImage from "../assets/img/carBox/carImage.jpg";
import {ReactComponent as Fuel} from "../assets/img/carBox/gas-station.svg";
import {ReactComponent as Cc} from "../assets/img/carBox/CC.svg";
import {ReactComponent as DescBody} from "../assets/img/car-description/body.svg";
import {ReactComponent as Map} from "../assets/img/icons/map.svg";
import {ReactComponent as Time} from "../assets/img/icons/time.svg";
import {ReactComponent as PageQuestion} from "../assets/img/icons/page-question.svg";
import {ReactComponent as ShowPhone} from "../assets/img/login/show-phone.svg";
import {ReactComponent as Mail} from "../assets/img/icons/send.svg";
import PageBox from "../layouts/pageBox";
import {useTranslation} from "react-i18next";
import {t} from "i18next";

const CarBox = (props) => {

    const { t, i18n } = useTranslation();

    return (
        <div className='carBox'>
            <div className='carBox__row'>
                <Link to={`/${i18n.language}/used-car/${props.ad.make_slug}/${props.ad.model_slug}/${props.ad.model_year}/${props.ad.city_slug}/${props.ad.code}`} className='carBox__img'>
                    <img src={props.ad.listing_image} alt={props.ad.title}/>
                </Link>
                <div className='carBox__content'>

                    <Link to={`/${i18n.language}/used-car/${props.ad.make_slug}/${props.ad.model_slug}/${props.ad.model_year}/${props.ad.city_slug}/${props.ad.code}`} className='carBox__title'><span className='carBox__model'>{props.ad.model_year}</span>{props.ad.title}&nbsp;{props.ad.model_name}</Link>

                    <div className='partNumbers mb-3'>
                        {/*<div className='partNumbers__label'>Part  number</div>*/}
                        <div className='partNumbers__row'>
                            { props.ad.fuel_title && <div className='partNumbers__item'><span className='partNumbers__icon'><Fuel/></span>{props.ad.fuel_title}</div>}
                            { props.ad.cc_title && <div className='partNumbers__item'><span className='partNumbers__icon'><Cc/></span>{props.ad.cc_title}</div>}
                            { props.ad.body_type_title && <div className='partNumbers__item'><span className='partNumbers__icon'><DescBody/></span>{props.ad.body_type_title}</div>}
                        </div>
                    </div>

                    <div className='carBox__footer'>

                        <Link to={`/${i18n.language}/mini-site/cars/${props.ad.merchant_id}/${props.ad.merchant_slug}`} className='medium-text mb-1'>{props.ad.company}</Link>

                        <div className='icon-links'>
                            <div className='icon-link'>
                                <div className='icon-link__icon'><Map/></div>
                                <div className='icon-link__label small-text'>{props.ad.city}</div>
                            </div>

                            <div className='icon-link'>
                                <div className='icon-link__icon'><Time/></div>
                                <div className='icon-link__label small-text'>{t('parts.LastUpdate')}: {props.ad.ad_date}</div>
                            </div>
                        </div>

                    </div>

                </div>

                <div className='carBox__actions'>
                    {/*<div className='icon-link'>*/}
                    {/*    <div className='icon-link__icon'><PageQuestion/></div>*/}
                    {/*    <div className='icon-link__label small-text'>Enquire</div>*/}
                    {/*</div>*/}

                    { props.ad.contact_choice == 1 && props.ad.phone && <a href={`tel:+${props.ad.phone_code}${props.ad.phone}`} target='_blank' rel='noopener' className='btn btn-secondary btn-icon btn-icon-left btn--phone'><ShowPhone/>{props.ad.phone}</a>}
                    { props.ad.contact_choice == 2 && props.ad.email && <a href={`mailto:${props.ad.email}`} target='_blank' rel='noopener' className='btn btn-secondary btn--phone'>{props.ad.email}</a>}

                    {/*<Link to="/" className='btn btn-secondary btn-icon btn-icon-left btn--phone'>*/}
                    {/*    <ShowPhone/>*/}
                    {/*    {props.ad.phone}*/}
                    {/*</Link>*/}
                </div>

            </div>
        </div>
    );
};

export default CarBox;